var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _g, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginCarousel01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 301,
    viewBox: "0 0 360 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2882 166.33C9.75834 160.807 2.96432 91.9672 80.1441 67.7428C157.323 43.5183 168.027 69.4328 240.7 28.3078C313.372 -12.8172 366.89 91.4044 358.44 166.33C349.99 241.256 316.188 248.016 316.188 248.016H30.0052C30.0052 248.016 14.2319 207.455 10.2882 166.33Z",
    fill: "#6476D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.183 123.938H271.387C271.919 122.392 273.195 121.192 274.775 120.744C275.299 118.538 277.277 116.899 279.643 116.899C280.471 116.899 281.257 117.102 281.95 117.465C282.778 116.84 283.809 116.477 284.924 116.477C285.634 116.477 286.318 116.629 286.927 116.899C287.299 116.806 287.687 116.755 288.093 116.755C290.349 116.755 292.25 118.251 292.876 120.305C293.036 120.288 293.205 120.279 293.374 120.279C295.664 120.279 297.599 121.834 298.183 123.938Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.446 87.883H189.619C190.101 85.6268 192.104 83.9367 194.503 83.9367C194.698 83.9367 194.901 83.9536 195.086 83.979C195.534 81.672 197.562 79.9228 199.996 79.9228C200.816 79.9228 201.585 80.1256 202.261 80.4721C203.131 79.7369 204.255 79.2891 205.489 79.2891C206.283 79.2891 207.027 79.4834 207.694 79.813C208.007 79.7454 208.328 79.7116 208.658 79.7116C210.965 79.7116 212.908 81.2833 213.483 83.4128C215.621 83.8522 217.26 85.6606 217.446 87.883Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1611 130.75H75.7628C75.3538 128.836 73.6553 127.403 71.6196 127.403C71.4548 127.403 71.2824 127.417 71.1253 127.438C70.7458 125.481 69.0254 123.998 66.961 123.998C66.2655 123.998 65.6131 124.171 65.0402 124.464C64.3017 123.84 63.3485 123.461 62.3023 123.461C61.6288 123.461 60.9976 123.626 60.4314 123.905C60.1661 123.848 59.894 123.819 59.6143 123.819C57.658 123.819 56.0094 125.153 55.5218 126.959C53.7092 127.331 52.3192 128.865 52.1611 130.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312.166 244.91H311.225V247.504H312.166V244.91Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.87 227.436V241.025C315.87 243.423 313.924 245.37 311.525 245.37H311.522C311.191 245.37 310.868 245.334 310.559 245.264C308.624 244.823 307.177 243.093 307.177 241.025V227.436C307.177 225.365 308.623 223.635 310.559 223.194C310.868 223.124 311.191 223.088 311.522 223.088H311.525C313.923 223.088 315.87 225.034 315.87 227.436Z",
    fill: "#66D17A",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2382 244.91H27.2969V247.504H28.2382V244.91Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9417 227.436V241.025C31.9417 243.423 29.9948 245.37 27.5966 245.37H27.5932C27.2628 245.37 26.9391 245.334 26.6307 245.264C24.6956 244.823 23.248 243.093 23.248 241.025V227.436C23.248 225.365 24.6947 223.635 26.6307 223.194C26.9391 223.124 27.2628 223.088 27.5932 223.088H27.5966C29.9948 223.088 31.9417 225.034 31.9417 227.436Z",
    fill: "#66D17A",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M310.477 169.209V247.735H248.41V169.209L280.248 151.138L310.477 169.209Z",
    fill: "#E3E5E4",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M310.105 171.5V176.195L279.444 156.388L248.762 176.21L248.701 171.591L279.444 151.761L310.105 171.5Z",
    fill: "#D1D5E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M315.468 176.195L279.443 152.926L243.42 176.195V171.569L279.443 148.301L315.468 171.569V176.195Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.713 206.961H267.642V209.376H272.713V206.961Z",
    fill: "#D1D5E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M289.747 204.486H284.675V206.901H289.747V204.486Z",
    fill: "#D1D5E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.426 167.354H279.354V169.769H284.426V167.354Z",
    fill: "#D1D5E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M257.256 197.542H252.185V199.957H257.256V197.542Z",
    fill: "#DFE3EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M303.143 198.749H298.071V201.164H303.143V198.749Z",
    fill: "#D1D5E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.397 238.359H280.325V240.774H285.397V238.359Z",
    fill: "#D1D5E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M265.548 178.683H258.688V185.543H265.548V178.683Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M272.455 178.683H265.594V185.543H272.455V178.683Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265.548 185.589H258.688V192.45H265.548V185.589Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M272.455 185.589H265.594V192.45H272.455V185.589Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M273.33 192.472H257.812V193.761H273.33V192.472Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M269.428 192.208H267.997L267.516 189.016H269.91L269.428 192.208Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M268.547 188.917C268.547 188.917 268.144 187.87 269.123 187.237C270.101 186.604 269.997 185.89 269.997 185.89",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M270.481 185.601C270.481 185.89 270.247 186.125 269.958 186.125C269.669 186.125 269.434 185.891 269.434 185.601C269.434 185.312 269.668 185.077 269.958 185.077C270.247 185.077 270.481 185.311 270.481 185.601Z",
    fill: "#EFD154",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M268.367 187.043C268.607 187.418 268.391 187.985 268.391 187.985C268.391 187.985 267.785 187.946 267.544 187.572C267.303 187.198 267.521 186.631 267.521 186.631C267.521 186.631 268.127 186.669 268.367 187.043Z",
    fill: "#6BDD91",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M269.773 188.441C269.356 188.593 268.85 188.257 268.85 188.257C268.85 188.257 269.021 187.674 269.439 187.522C269.856 187.37 270.362 187.706 270.362 187.706C270.362 187.706 270.191 188.289 269.773 188.441Z",
    fill: "#6BDD91",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M270.971 184.547C270.808 184.961 270.221 185.117 270.221 185.117C270.221 185.117 269.897 184.604 270.061 184.19C270.223 183.775 270.81 183.619 270.81 183.619C270.81 183.619 271.133 184.133 270.971 184.547Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M269.564 184.196C269.841 184.543 269.683 185.13 269.683 185.13C269.683 185.13 269.076 185.153 268.799 184.805C268.522 184.458 268.68 183.871 268.68 183.871C268.68 183.871 269.286 183.849 269.564 184.196Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M268.556 185.239C268.996 185.173 269.425 185.603 269.425 185.603C269.425 185.603 269.141 186.14 268.702 186.207C268.262 186.273 267.833 185.843 267.833 185.843C267.833 185.843 268.116 185.305 268.556 185.239Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M268.956 186.632C269.118 186.218 269.705 186.062 269.705 186.062C269.705 186.062 270.029 186.576 269.866 186.989C269.704 187.403 269.116 187.56 269.116 187.56C269.116 187.56 268.794 187.046 268.956 186.632Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M270.362 186.984C270.085 186.637 270.243 186.05 270.243 186.05C270.243 186.05 270.85 186.027 271.127 186.375C271.404 186.722 271.246 187.309 271.246 187.309C271.246 187.309 270.639 187.332 270.362 186.984Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M271.37 185.94C270.93 186.006 270.501 185.576 270.501 185.576C270.501 185.576 270.785 185.039 271.224 184.973C271.664 184.907 272.093 185.336 272.093 185.336C272.093 185.336 271.81 185.874 271.37 185.94Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M257.467 193.917L260.165 196.616L276.657 196.717L273.586 193.705L257.467 193.917Z",
    fill: "#D1D5E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M293 178.642H286.14V185.502H293V178.642Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.907 178.642H293.046V185.502H299.907V178.642Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M293 178.642H286.14V181.622H293V178.642Z",
    fill: "#6172A3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M299.907 178.642H293.046V181.622H299.907V178.642Z",
    fill: "#6172A3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M293 185.548H286.14V192.409H293V185.548Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M299.907 185.548H293.046V192.409H299.907V185.548Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M300.782 192.431H285.265V193.72H300.782V192.431Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M285.028 193.917L287.727 196.616L304.22 196.717L301.148 193.705L285.028 193.917Z",
    fill: "#D1D5E0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M293 213.394H286.14V220.254H293V213.394Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M299.907 213.394H293.046V220.254H299.907V213.394Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M293 213.394H286.14V216.374H293V213.394Z",
    fill: "#6172A3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M299.907 213.394H293.046V216.374H299.907V213.394Z",
    fill: "#6172A3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M293 220.3H286.14V227.161H293V220.3Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M299.907 220.3H293.046V227.161H299.907V220.3Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M300.782 227.183H285.265V228.472H300.782V227.183Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M285.028 228.669L287.727 231.368L304.22 231.469L301.148 228.457L285.028 228.669Z",
    fill: "#D1D5E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M266.066 213.395H259.205V220.255H266.066V213.395Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M272.972 213.395H266.111V220.255H272.972V213.395Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M266.066 213.395H259.205V216.375H266.066V213.395Z",
    fill: "#6172A3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.972 213.395H266.111V216.375H272.972V213.395Z",
    fill: "#6172A3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M266.066 220.301H259.205V227.162H266.066V220.301Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M272.972 220.301H266.111V227.162H272.972V220.301Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M273.847 227.184H258.33V228.473H273.847V227.184Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M258.094 228.67L260.793 231.369L277.285 231.47L274.213 228.458L258.094 228.67Z",
    fill: "#D1D5E0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M120.424 187.51H30.4639V247.75H120.424V187.51Z",
    fill: "#E3E5E4",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M120.398 188.26H30.7891V191.937H120.398V188.26Z",
    fill: "#D1D5E0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6445 247.243L81.0585 189.281V246.815L39.6445 247.243Z",
    fill: "#D1D5E0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M177.992 187.898H29.1416L48.5249 163.54H158.608L177.992 187.898Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M208.784 187.898H59.9346L79.3178 163.54H189.401L208.784 187.898Z",
    fill: "#6172A3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M95.593 212.672H43.2139V247.64H95.593V212.672Z",
    fill: "#9696AA",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0982 214.16H44.708V247.639H94.0982V214.16Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 223.196H46.4277V225.593H92.2798V223.196Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1146 223.306H46.5938V225.483H92.1146V223.306Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9022 223.449H46.8047V225.34H91.9022V223.449Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 219.197H46.4277V221.594H92.2798V219.197Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1146 219.307H46.5938V221.484H92.1146V219.307Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9022 219.449H46.8047V221.34H91.9022V219.449Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 227.234H46.4277V229.631H92.2798V227.234Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1146 227.345H46.5938V229.522H92.1146V227.345Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9022 227.488H46.8047V229.379H91.9022V227.488Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 231.272H46.4277V233.669H92.2798V231.272Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1146 231.382H46.5938V233.559H92.1146V231.382Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9022 231.524H46.8047V233.415H91.9022V231.524Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 235.311H46.4277V237.707H92.2798V235.311Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1146 235.42H46.5938V237.598H92.1146V235.42Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9022 235.562H46.8047V237.453H91.9022V235.562Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 239.348H46.4277V241.744H92.2798V239.348Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1146 239.458H46.5938V241.636H92.1146V239.458Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9022 239.601H46.8047V241.491H91.9022V239.601Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2798 243.386H46.4277V245.782H92.2798V243.386Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1146 243.495H46.5938V245.673H92.1146V243.495Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9022 243.638H46.8047V245.528H91.9022V243.638Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0703 214.16H92.4992H94.4605V215.779V247.64H59.4831L76.2273 215.779H45.0703V214.16Z",
    fill: "#DFE3EF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M266.994 170.126H80.4561V247.749H266.994V170.126Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M266.647 193.146L80.8164 174.307V171.088H266.647V193.146Z",
    fill: "#DFE3EF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M247.297 212.562H227.237C227.237 208.773 230.309 205.701 234.098 205.701H240.436C244.225 205.701 247.297 208.773 247.297 212.562Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M247.371 214.157H227.178V247.364H247.371V214.157Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M247.371 214.338H227.178V215.847H247.371V214.338Z",
    fill: "#6172A3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M247.369 215.425H244.981V247.545H247.369V215.425Z",
    fill: "#6172A3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3408 179.983H53.6469",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9336 171.168H65.2389",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7334 177.568H78.0395",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M237.032 205.945V212.506",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M246.747 210.116H227.759",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M231.317 229.974C231.317 230.53 230.866 230.981 230.31 230.981C229.754 230.981 229.304 230.53 229.304 229.974C229.304 229.418 229.754 228.968 230.31 228.968C230.866 228.968 231.317 229.418 231.317 229.974Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M170.255 202.724H165.184V205.139H170.255V202.724Z",
    fill: "#DFE3EF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M256.232 201.115H251.16V203.53H256.232V201.115Z",
    fill: "#DFE3EF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M172.468 218.744H167.396V221.159H172.468V218.744Z",
    fill: "#DFE3EF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7711 232.753H87.6992V235.168H92.7711V232.753Z",
    fill: "#DFE3EF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M223.384 195.175H218.312V197.59H223.384V195.175Z",
    fill: "#DFE3EF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M176.655 236.053H171.583V238.468H176.655V236.053Z",
    fill: "#DFE3EF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9672 242.305H34.4688V243.971H37.9672V242.305Z",
    fill: "#D1D5E0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9662 199.919H60.4678V201.585H63.9662V199.919Z",
    fill: "#D1D5E0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1381 197.573H40.6396V199.24H44.1381V197.573Z",
    fill: "#D1D5E0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M49.64 207.043H46.1416V208.709H49.64V207.043Z",
    fill: "#D1D5E0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8773 225.772H32.3789V227.439H35.8773V225.772Z",
    fill: "#D1D5E0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M187.483 215.605H182.411V218.021H187.483V215.605Z",
    fill: "#DFE3EF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M218.166 235.4H213.094V237.815H218.166V235.4Z",
    fill: "#DFE3EF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M135.799 196.769H130.728V199.184H135.799V196.769Z",
    fill: "#DFE3EF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3541 209.004H91.2822V211.419H96.3541V209.004Z",
    fill: "#DFE3EF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M99.582 196.666L102.281 199.364L118.773 199.465L115.702 196.453L99.582 196.666Z",
    fill: "#DFE3EF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M107.625 181.37H100.765V183.561H107.625V181.37Z",
    fill: "#6172A3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 181.37H107.671V183.561H114.532V181.37Z",
    fill: "#6172A3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M107.625 188.276H100.765V195.137H107.625V188.276Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M114.532 188.276H107.671V195.137H114.532V188.276Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M115.407 195.159H99.8896V196.449H115.407V195.159Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M145.469 196.666L148.168 199.364L164.66 199.465L161.589 196.453L145.469 196.666Z",
    fill: "#DFE3EF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 181.37H146.651V183.561H153.512V181.37Z",
    fill: "#6172A3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M160.418 181.37H153.558V183.561H160.418V181.37Z",
    fill: "#6172A3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 188.276H146.651V195.137H153.512V188.276Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M160.418 188.276H153.558V195.137H160.418V188.276Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M161.294 195.159H145.776V196.449H161.294V195.159Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 196.666L194.054 199.364L210.547 199.465L207.475 196.453L191.355 196.666Z",
    fill: "#DFE3EF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M199.398 181.37H192.537V188.231H199.398V181.37Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M206.305 181.37H199.444V188.231H206.305V181.37Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M199.398 181.37H192.537V184.934H199.398V181.37Z",
    fill: "#6172A3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M206.305 181.37H199.444V184.934H206.305V181.37Z",
    fill: "#6172A3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M199.398 188.276H192.537V195.137H199.398V188.276Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M206.305 188.276H199.444V195.137H206.305V188.276Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M207.179 195.159H191.662V196.449H207.179V195.159Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M237.242 196.666L239.94 199.364L256.434 199.465L253.362 196.453L237.242 196.666Z",
    fill: "#DFE3EF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M245.285 181.37H238.424V188.231H245.285V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M252.192 181.37H245.331V188.231H252.192V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M107.624 181.37H100.764V188.231H107.624V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M114.531 181.37H107.67V188.231H114.531V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 181.37H146.651V188.231H153.512V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M160.417 181.37H153.557V188.231H160.417V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M245.285 181.37H238.424V188.231H245.285V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M252.192 181.37H245.331V188.231H252.192V181.37Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M107.624 181.37H100.764V183.561H107.624V181.37Z",
    fill: "#6172A3"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M114.531 181.37H107.67V183.561H114.531V181.37Z",
    fill: "#6172A3"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 181.37H146.651V183.561H153.512V181.37Z",
    fill: "#6172A3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M160.417 181.37H153.557V183.561H160.417V181.37Z",
    fill: "#6172A3"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M107.624 181.37H100.764V183.561H107.624V181.37Z",
    fill: "#6172A3"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M114.531 181.37H107.67V183.561H114.531V181.37Z",
    fill: "#6172A3"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M153.512 181.37H146.651V183.561H153.512V181.37Z",
    fill: "#6172A3"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M160.417 181.37H153.557V183.561H160.417V181.37Z",
    fill: "#6172A3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M245.285 181.37H238.424V183.561H245.285V181.37Z",
    fill: "#6172A3"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M252.192 181.37H245.331V183.561H252.192V181.37Z",
    fill: "#6172A3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M245.285 188.276H238.424V195.137H245.285V188.276Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M252.192 188.276H245.331V195.137H252.192V188.276Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M253.066 195.159H237.549V196.449H253.066V195.159Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M108.427 237.782L111.125 240.48L155.603 240.601L152.531 237.59L108.427 237.782Z",
    fill: "#DFE3EF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M116.569 208.43H109.708V215.29H116.569V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 208.43H116.614V215.29H123.475V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M116.569 215.338H109.708V222.199H116.569V215.338Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 215.338H116.614V222.199H123.475V215.338Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M130.396 208.43H123.535V215.29H130.396V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M137.302 208.43H130.441V215.29H137.302V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M130.395 215.338H123.534V222.199H130.395V215.338Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M137.302 215.338H130.441V222.199H137.302V215.338Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 208.43H137.36V215.29H144.221V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M151.128 208.43H144.268V215.29H151.128V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M116.569 208.43H109.708V215.29H116.569V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 208.43H116.614V215.29H123.475V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M130.395 208.43H123.534V215.29H130.395V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M137.302 208.43H130.441V215.29H137.302V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 208.43H137.36V215.29H144.221V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M151.128 208.43H144.268V215.29H151.128V208.43Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M116.569 208.43H109.708V218.381H116.569V208.43Z",
    fill: "#6172A3"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 208.43H116.614V218.381H123.475V208.43Z",
    fill: "#6172A3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M130.395 208.43H123.534V218.381H130.395V208.43Z",
    fill: "#6172A3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M137.302 208.43H130.441V218.381H137.302V208.43Z",
    fill: "#6172A3"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 208.43H137.36V218.381H144.221V208.43Z",
    fill: "#6172A3"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M151.128 208.43H144.268V218.381H151.128V208.43Z",
    fill: "#6172A3"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 215.338H137.36V222.199H144.221V215.338Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M151.128 215.338H144.268V222.199H151.128V215.338Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M116.569 222.317H109.708V229.178H116.569V222.317Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 222.317H116.614V229.178H123.475V222.317Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M116.569 229.224H109.708V236.084H116.569V229.224Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M123.475 229.224H116.614V236.084H123.475V229.224Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M130.396 222.317H123.535V229.178H130.396V222.317Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M137.302 222.317H130.441V229.178H137.302V222.317Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M130.395 229.224H123.534V236.084H130.395V229.224Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M137.302 229.224H130.441V236.084H137.302V229.224Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 222.317H137.36V229.178H144.221V222.317Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M151.128 222.317H144.268V229.178H151.128V222.317Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M144.221 229.224H137.36V236.084H144.221V229.224Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M151.128 229.224H144.268V236.084H151.128V229.224Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M152.273 236.229H108.563V237.518H152.273V236.229Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M231.064 116.164H224.372V134.036H231.064V116.164Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M228.458 116.164H217.288V134.036H228.458V116.164Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M222.954 121.599H219.361V123.53H222.954V121.599Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M220.799 125.1H217.207V127.031H220.799V125.1Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M228.789 117.884H225.197V119.816H228.789V117.884Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M228.588 125.2H224.996V127.132H228.588V125.2Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M229.313 121.536H225.721V123.468H229.313V121.536Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M220.448 118.246H216.855V120.178H220.448V118.246Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6041 238.375H77.4346V247.48H88.6041V238.375Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0991 241.145H79.5068V242.129H83.0991V241.145Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9457 242.929H77.3535V243.913H80.9457V242.929Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M88.936 239.253H85.3438V240.237H88.936V239.253Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7348 242.979H85.1426V243.964H88.7348V242.979Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8393 245.603H77.2471V246.587H80.8393V245.603Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9721 245.133H85.3799V246.117H88.9721V245.133Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1156 241.086H85.5234V242.07H89.1156V241.086Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5942 239.437H77.002V240.421H80.5942V239.437Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M268.878 238.64H257.708V247.745H268.878V238.64Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M263.373 241.407H259.781V242.392H263.373V241.407Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M261.219 243.191H257.627V244.176H261.219V243.191Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M269.209 239.516H265.617V240.5H269.209V239.516Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M269.008 243.242H265.416V244.227H269.008V243.242Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M261.113 245.867H257.521V246.852H261.113V245.867Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M269.247 245.396H265.654V246.38H269.247V245.396Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M269.389 241.351H265.797V242.335H269.389V241.351Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M260.868 239.7H257.275V240.685H260.868V239.7Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.612,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M311.938 241.232H303.819V247.85H311.938V241.232Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M307.937 243.245H305.326V243.961H307.937V243.245Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M306.372 244.542H303.761V245.258H306.372V244.542Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M312.179 241.87H309.568V242.586H312.179V241.87Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M312.033 244.578H309.422V245.294H312.033V244.578Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M306.295 246.486H303.684V247.202H306.295V246.486Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M312.205 246.144H309.594V246.859H312.205V246.144Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M312.31 243.204H309.699V243.92H312.31V243.204Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M306.116 242.005H303.505V242.721H306.116V242.005Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.4448,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M270.007 171.496H77.4434L102.519 128.662H244.931L270.007 171.496Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M119.236 139.51L148.197 171.429H167.599L133.143 133.412L119.236 139.51Z",
    fill: "#6172A3"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M240.745 219.582H233.884V226.443H240.745V219.582Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M240.745 237.18H233.884V238.951H240.745V237.18Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M144.262 158.857L156.532 171.126H241.339L206.865 136.651L144.262 158.857Z",
    fill: "#6172A3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M206.33 114.499V158.857H144.262V114.499L176.1 96.4268L206.33 114.499Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M205.956 116.789V121.484L175.296 101.677L144.613 121.498L144.553 116.879L175.296 97.0498L205.956 116.789Z",
    fill: "#DFE3EF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M211.319 121.483L175.296 98.2146L139.271 121.483V116.858L175.296 93.5889L211.319 116.858V121.483Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M111.91 136.27H119.215",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M128.173 142.871H135.478",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M212.097 134.177H219.403",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M233.953 139.489H241.258",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M221.998 149.633H229.303",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M245.827 162.836H253.132",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0293 151.646H106.335",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M126.401 162.595H133.707",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M168.565 152.249H163.493V154.664H168.565V152.249Z",
    fill: "#DFE3EF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M180.278 112.643H175.206V115.058H180.278V112.643Z",
    fill: "#DFE3EF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M153.108 142.831H148.036V145.246H153.108V142.831Z",
    fill: "#DFE3EF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M198.995 144.038H193.923V146.453H198.995V144.038Z",
    fill: "#DFE3EF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M161.4 123.972H154.539V130.832H161.4V123.972Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M168.306 123.972H161.445V130.832H168.306V123.972Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M161.4 130.878H154.539V137.739H161.4V130.878Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M168.306 130.878H161.445V137.739H168.306V130.878Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M169.181 137.762H153.664V139.051H169.181V137.762Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M165.277 137.497H163.846L163.364 134.306H165.758L165.277 137.497Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M164.397 134.205C164.397 134.205 163.994 133.158 164.972 132.525C165.951 131.892 165.847 131.178 165.847 131.178",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M165.807 131.414C166.096 131.414 166.331 131.179 166.331 130.89C166.331 130.601 166.096 130.366 165.807 130.366C165.518 130.366 165.283 130.601 165.283 130.89C165.283 131.179 165.518 131.414 165.807 131.414Z",
    fill: "#EFD154",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M164.218 132.332C164.459 132.707 164.242 133.274 164.242 133.274C164.242 133.274 163.636 133.235 163.395 132.861C163.154 132.487 163.371 131.92 163.371 131.92C163.371 131.92 163.977 131.958 164.218 132.332Z",
    fill: "#6BDD91",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M165.623 133.731C165.205 133.884 164.699 133.547 164.699 133.547C164.699 133.547 164.871 132.965 165.288 132.813C165.706 132.661 166.212 132.997 166.212 132.997C166.212 132.997 166.041 133.579 165.623 133.731Z",
    fill: "#6BDD91",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M166.82 129.836C166.658 130.25 166.071 130.406 166.071 130.406C166.071 130.406 165.747 129.892 165.91 129.479C166.072 129.065 166.66 128.908 166.66 128.908C166.66 128.908 166.983 129.422 166.82 129.836Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M165.413 129.485C165.69 129.832 165.532 130.418 165.532 130.418C165.532 130.418 164.926 130.441 164.648 130.093C164.371 129.746 164.529 129.158 164.529 129.158C164.529 129.158 165.136 129.137 165.413 129.485Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M164.406 130.527C164.845 130.461 165.275 130.892 165.275 130.892C165.275 130.892 164.991 131.428 164.551 131.495C164.112 131.561 163.683 131.131 163.683 131.131C163.683 131.131 163.967 130.593 164.406 130.527Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M164.806 131.921C164.968 131.507 165.555 131.351 165.555 131.351C165.555 131.351 165.879 131.865 165.716 132.278C165.554 132.692 164.966 132.849 164.966 132.849C164.966 132.849 164.643 132.335 164.806 131.921Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M166.212 132.272C165.935 131.925 166.093 131.338 166.093 131.338C166.093 131.338 166.699 131.315 166.977 131.664C167.254 132.011 167.096 132.598 167.096 132.598C167.096 132.598 166.489 132.62 166.212 132.272Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M167.219 131.23C166.78 131.296 166.351 130.867 166.351 130.867C166.351 130.867 166.635 130.33 167.074 130.264C167.513 130.198 167.943 130.628 167.943 130.628C167.943 130.628 167.659 131.165 167.219 131.23Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M153.317 139.206L156.016 141.904L172.509 142.006L169.437 138.994L153.317 139.206Z",
    fill: "#DFE3EF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M192.23 226.551L194.929 229.25L211.422 229.351L208.35 226.339L192.23 226.551Z",
    fill: "#DFE3EF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M200.365 211.316H193.504V218.177H200.365V211.316Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M207.271 211.316H200.41V218.177H207.271V211.316Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M200.365 218.223H193.504V225.083H200.365V218.223Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M207.271 218.223H200.41V225.083H207.271V218.223Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M208.146 225.106H192.629V226.396H208.146V225.106Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M203.895 224.801H202.464L201.982 221.608H204.376L203.895 224.801Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M203.015 221.509C203.015 221.509 202.612 220.461 203.59 219.828C204.569 219.195 204.465 218.481 204.465 218.481",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M204.425 218.718C204.715 218.718 204.949 218.483 204.949 218.194C204.949 217.905 204.715 217.67 204.425 217.67C204.136 217.67 203.901 217.905 203.901 218.194C203.901 218.483 204.136 218.718 204.425 218.718Z",
    fill: "#EFD154",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M202.835 219.636C203.075 220.01 202.859 220.577 202.859 220.577C202.859 220.577 202.253 220.538 202.012 220.164C201.771 219.79 201.988 219.223 201.988 219.223C201.988 219.223 202.594 219.262 202.835 219.636Z",
    fill: "#6BDD91",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M204.24 221.035C203.823 221.187 203.316 220.851 203.316 220.851C203.316 220.851 203.488 220.268 203.905 220.116C204.323 219.964 204.829 220.3 204.829 220.3C204.829 220.3 204.658 220.883 204.24 221.035Z",
    fill: "#6BDD91",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M205.438 217.14C205.276 217.554 204.689 217.71 204.689 217.71C204.689 217.71 204.366 217.196 204.528 216.782C204.691 216.368 205.278 216.212 205.278 216.212C205.278 216.212 205.6 216.726 205.438 217.14Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M204.031 216.789C204.308 217.137 204.15 217.723 204.15 217.723C204.15 217.723 203.544 217.746 203.267 217.398C202.989 217.051 203.147 216.464 203.147 216.464C203.147 216.464 203.754 216.441 204.031 216.789Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M203.023 217.831C203.463 217.765 203.892 218.195 203.892 218.195C203.892 218.195 203.608 218.732 203.168 218.799C202.729 218.865 202.3 218.435 202.3 218.435C202.3 218.435 202.584 217.897 203.023 217.831Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M203.423 219.225C203.585 218.811 204.172 218.654 204.172 218.654C204.172 218.654 204.495 219.169 204.333 219.582C204.171 219.996 203.583 220.153 203.583 220.153C203.583 220.153 203.26 219.639 203.423 219.225Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M204.829 219.577C204.552 219.229 204.71 218.643 204.71 218.643C204.71 218.643 205.317 218.62 205.594 218.967C205.871 219.315 205.713 219.902 205.713 219.902C205.713 219.902 205.106 219.924 204.829 219.577Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M205.837 218.533C205.398 218.599 204.969 218.17 204.969 218.17C204.969 218.17 205.253 217.633 205.692 217.566C206.132 217.501 206.561 217.931 206.561 217.931C206.561 217.931 206.277 218.467 205.837 218.533Z",
    fill: "#F26D8C",
    stroke: "#6172A3",
    strokeWidth: 0.5716,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M188.851 123.931H181.99V130.791H188.851V123.931Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M195.757 123.931H188.896V130.791H195.757V123.931Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M188.851 123.931H181.99V126.911H188.851V123.931Z",
    fill: "#6172A3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M195.757 123.931H188.896V126.911H195.757V123.931Z",
    fill: "#6172A3"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M188.851 130.837H181.99V137.698H188.851V130.837Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M195.757 130.837H188.896V137.698H195.757V130.837Z",
    fill: "#829AD8",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 137.721H181.116V139.01H196.633V137.721Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M180.88 139.206L183.578 141.904L200.071 142.006L197 138.994L180.88 139.206Z",
    fill: "#DFE3EF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M133.012 133.734L130.285 139.51L126.32 121.639H133.012V133.734Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M130.406 121.639H119.236V139.51H130.406V121.639Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M124.901 127.073H121.309V129.005H124.901V127.073Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 130.575H119.155V132.507H122.747V130.575Z",
    fill: "#FFB27D",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M130.738 123.359H127.146V125.291H130.738V123.359Z",
    fill: "#C17561",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M130.537 130.675H126.944V132.607H130.537V130.675Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M124.104 135.401H120.512V137.333H124.104V135.401Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M131.261 127.013H127.669V128.944H131.261V127.013Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M122.396 123.721H118.804V125.652H122.396V123.721Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M130.212 134.812H126.62V136.744H130.212V134.812Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M298.956 217.937H298.952C298.551 217.937 298.16 217.981 297.786 218.066C295.442 218.6 293.69 220.694 293.69 223.203V239.659C293.69 242.163 295.443 244.257 297.786 244.792C298.047 244.851 298.318 244.882 298.592 244.901V247.506H299.732V244.857C302.268 244.481 304.218 242.3 304.218 239.66V223.204C304.218 220.293 301.86 217.937 298.956 217.937Z",
    fill: "#D1D5E0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M297.092 244.364H295.952V247.505H297.092V244.364Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M301.577 223.203V239.659C301.577 242.563 299.22 244.92 296.316 244.92H296.312C295.911 244.92 295.52 244.875 295.147 244.791C292.803 244.256 291.051 242.162 291.051 239.658V223.202C291.051 220.693 292.803 218.599 295.147 218.065C295.52 217.98 295.911 217.936 296.312 217.936H296.316C299.22 217.937 301.577 220.294 301.577 223.203Z",
    fill: "#66D17A",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M175.526 211.035H175.521C175.028 211.035 174.544 211.09 174.084 211.194C171.193 211.852 169.031 214.436 169.031 217.53V237.827C169.031 240.915 171.193 243.499 174.084 244.157C174.405 244.23 174.739 244.268 175.078 244.291V247.504H176.484V244.237C179.612 243.773 182.017 241.082 182.017 237.826V217.529C182.016 213.942 179.108 211.035 175.526 211.035Z",
    fill: "#D1D5E0"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M173.226 243.629H171.82V247.503H173.226V243.629Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M178.758 217.529V237.826C178.758 241.408 175.85 244.316 172.268 244.316H172.262C171.769 244.316 171.285 244.261 170.825 244.157C167.934 243.499 165.772 240.914 165.772 237.827V217.53C165.772 214.436 167.934 211.852 170.825 211.194C171.285 211.09 171.769 211.035 172.262 211.035H172.268C175.851 211.034 178.758 213.941 178.758 217.529Z",
    fill: "#66D17A",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5892 221.061H99.585C99.2267 221.061 98.8769 221.1 98.5431 221.176C96.4466 221.654 94.8799 223.527 94.8799 225.771V240.488C94.8799 242.727 96.4474 244.6 98.5431 245.078C98.7755 245.13 99.018 245.159 99.2639 245.175V247.505H100.283V245.136C102.551 244.8 104.294 242.849 104.294 240.488V225.771C104.295 223.168 102.187 221.061 99.5892 221.061Z",
    fill: "#D1D5E0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9215 244.696H96.9023V247.505H97.9215V244.696Z",
    fill: "#C96A50",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M101.933 225.771V240.488C101.933 243.085 99.8245 245.194 97.2269 245.194H97.2227C96.8644 245.194 96.5146 245.154 96.1808 245.078C94.0843 244.6 92.5176 242.727 92.5176 240.488V225.771C92.5176 223.527 94.0851 221.654 96.1808 221.176C96.5146 221.101 96.8653 221.061 97.2227 221.061H97.2269C99.8245 221.061 101.933 223.169 101.933 225.771Z",
    fill: "#66D17A",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M19.583 247.7H326.328",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M251.121 262.381H298.231",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M167.182 254.212H190.279",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M36.625 287.591H144.225",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0.428711 263.648H41.9762",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M198.165 274.211H216.052",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M312.667 280.972H330.554",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M157.604 300.407H169.576",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0322 45.4911C48.0322 45.4911 49.7223 39.8573 57.8912 43.0971C57.8912 43.0971 58.2782 35.9144 66.764 38.3793",
    stroke: "#E7EDF7",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1377 55.9805C48.1377 55.9805 49.0461 52.9519 53.4377 54.6935C53.4377 54.6935 53.6456 50.8317 58.2079 52.1567",
    stroke: "#E7EDF7",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7422 46.353C70.7422 46.353 71.7841 42.8799 76.8205 44.8767C76.8205 44.8767 77.0596 40.4479 82.2912 41.9681",
    stroke: "#E7EDF7",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6873_16150",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 159,
    width: 100,
    height: 89
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M158.731 159.146H59.0176V247.874H158.731V159.146Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6873_16150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.416 171.905H124.09V171.525H116.548V171.905H79.368C77.4642 171.905 75.9211 173.448 75.9211 175.352V195.07H75.4961V202.612H75.9211V205.145H75.4961V216.052H75.9211V284.262C75.9211 286.166 77.4642 287.709 79.368 287.709H129.416C131.32 287.709 132.863 286.166 132.863 284.262V175.351C132.863 173.448 131.32 171.905 129.416 171.905Z",
    fill: "#D1D5E0"
  }))), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9345 195.068H70.2148V202.611H71.9345V195.068Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M118.81 173.245V171.525H111.267V173.245H118.81Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9345 205.144H70.2148V216.051H71.9345V205.144Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M124.134 287.708H74.0865C72.1827 287.708 70.6396 286.165 70.6396 284.261V175.351C70.6396 173.447 72.1827 171.904 74.0865 171.904H124.134C126.038 171.904 127.581 173.447 127.581 175.351V284.262C127.581 286.165 126.038 287.708 124.134 287.708Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M123.979 273.214H74.2421C73.5804 273.214 73.043 272.678 73.043 272.016V185.526C73.043 184.865 73.5796 184.328 74.2421 184.328H123.979C124.64 184.328 125.177 184.865 125.177 185.526V272.016C125.178 272.678 124.641 273.214 123.979 273.214Z",
    fill: "#2F2A89"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M123.979 273.214H74.2421C73.5804 273.214 73.043 272.678 73.043 272.016V185.526C73.043 184.865 73.5796 184.328 74.2421 184.328H123.979C124.64 184.328 125.177 184.865 125.177 185.526V272.016C125.178 272.678 124.641 273.214 123.979 273.214Z",
    fill: "url(#pattern0_6873_16150)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M123.979 273.214H74.2421C73.5804 273.214 73.043 272.678 73.043 272.016V185.526C73.043 184.865 73.5796 184.328 74.2421 184.328H123.979C124.64 184.328 125.177 184.865 125.177 185.526V272.016C125.178 272.678 124.641 273.214 123.979 273.214Z",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M105.803 179.224H92.1588C91.6686 179.224 91.2715 178.827 91.2715 178.336C91.2715 177.846 91.6686 177.449 92.1588 177.449H105.803C106.293 177.449 106.69 177.846 106.69 178.336C106.69 178.827 106.293 179.224 105.803 179.224Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M111.293 178.338C111.293 178.751 110.958 179.086 110.545 179.086C110.131 179.086 109.796 178.751 109.796 178.338C109.796 177.924 110.131 177.589 110.545 177.589C110.958 177.589 111.293 177.924 111.293 178.338Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M116.312 178.338C116.312 178.583 116.114 178.782 115.868 178.782C115.623 178.782 115.425 178.583 115.425 178.338C115.425 178.093 115.623 177.895 115.868 177.895C116.114 177.895 116.312 178.093 116.312 178.338Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M102.013 282.828H95.9122C94.1664 282.828 92.751 281.413 92.751 279.667C92.751 277.921 94.1664 276.506 95.9122 276.506H102.013C103.759 276.506 105.175 277.921 105.175 279.667C105.175 281.413 103.759 282.828 102.013 282.828Z",
    fill: "white",
    stroke: "#6172A3",
    strokeWidth: 0.8574,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M290.664 75.8945C294.916 75.4227 298.506 78.7337 298.506 82.8828C298.506 84.411 298.012 85.8235 297.179 86.9902C295.778 88.9247 295.004 91.2403 294.951 93.6279H287.987C287.928 91.1814 287.049 88.8608 285.673 86.8691L285.672 86.8682C284.755 85.5441 284.288 83.8815 284.474 82.1016C284.823 78.8751 287.444 76.2491 290.663 75.8945H290.664Z",
    fill: "white",
    stroke: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M294.273 95.2842V96.5869H288.665V95.2842H294.273Z",
    fill: "white",
    stroke: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M293.287 98.2461V98.8086H289.652V98.2461H293.287Z",
    fill: "white",
    stroke: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M291.081 69.6299C300.895 69.6299 308.881 77.6154 308.881 87.4297C308.881 97.244 300.895 105.229 291.081 105.229C281.267 105.229 273.281 97.244 273.281 87.4297C273.281 77.6154 281.267 69.63 291.081 69.6299ZM291.081 70.7822C281.902 70.7823 274.435 78.2495 274.435 87.4287C274.435 96.6089 281.902 104.076 291.081 104.076C300.26 104.076 307.728 96.6081 307.728 87.4287C307.727 78.2495 300.26 70.7822 291.081 70.7822Z",
    fill: "white",
    stroke: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M113.662 40.4902C123.476 40.4902 131.462 48.4758 131.462 58.29C131.462 68.1044 123.476 76.0898 113.662 76.0898C103.848 76.0898 95.8623 68.1043 95.8623 58.29C95.8624 48.4758 103.848 40.4903 113.662 40.4902ZM113.662 41.6436C104.483 41.6436 97.0157 49.1099 97.0156 58.29C97.0156 67.4694 104.483 74.9365 113.662 74.9365C122.841 74.9365 130.309 67.4695 130.309 58.29C130.309 49.1107 122.841 41.6436 113.662 41.6436Z",
    fill: "white",
    stroke: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M113.662 46.7334C120.035 46.7334 125.22 51.9185 125.22 58.291C125.22 64.6636 120.035 69.8486 113.662 69.8486C107.29 69.8486 102.104 64.6635 102.104 58.291C102.105 51.9185 107.29 46.7334 113.662 46.7334ZM113.989 49.6094C113.989 49.791 113.843 49.9365 113.663 49.9365C113.482 49.9365 113.336 49.7898 113.336 49.6094V47.3877L112.796 47.4297C110.425 47.6176 108.269 48.5639 106.566 50.0283L106.158 50.3789L106.539 50.7607L107.695 51.917V51.918C107.822 52.0443 107.823 52.2511 107.695 52.3789C107.631 52.443 107.548 52.4746 107.464 52.4746C107.38 52.4746 107.297 52.4432 107.232 52.3789L105.694 50.8408L105.344 51.2549C103.902 52.9571 102.978 55.106 102.799 57.4609L102.758 57.998H104.876C105.056 57.998 105.203 58.145 105.203 58.3252C105.203 58.5052 105.056 58.6514 104.876 58.6514H102.758L102.802 59.1924C102.995 61.53 103.925 63.6599 105.363 65.3477L105.715 65.7598L107.184 64.291C107.311 64.1635 107.519 64.1635 107.646 64.291C107.774 64.4186 107.774 64.6264 107.646 64.7539L106.56 65.8398L106.177 66.2227L106.588 66.5742C108.27 68.0128 110.391 68.9472 112.723 69.1475L113.266 69.1943V67.1094C113.266 66.9301 113.412 66.7833 113.593 66.7832C113.773 66.7832 113.919 66.9294 113.919 67.1094V69.1934L114.455 69.1553C116.798 68.9853 118.941 68.0799 120.644 66.6572L121.062 66.3066L120.676 65.9199L119.56 64.8027C119.432 64.6752 119.432 64.4674 119.56 64.3398C119.687 64.2127 119.894 64.2126 120.021 64.3398L121.525 65.8438L121.877 65.4395C123.345 63.7544 124.308 61.6192 124.519 59.2656L124.567 58.7217H122.38C122.2 58.7217 122.053 58.5752 122.053 58.3945C122.053 58.2144 122.2 58.0674 122.38 58.0674H124.566L124.529 57.5332C124.365 55.1583 123.444 52.9883 121.995 51.2715L121.645 50.8564L121.26 51.2402L120.071 52.4287C120.008 52.4919 119.925 52.5244 119.84 52.5244C119.756 52.5243 119.673 52.4917 119.609 52.4277C119.482 52.3002 119.482 52.0934 119.609 51.9658L120.801 50.7744L121.181 50.3936L120.773 50.042C119.068 48.5697 116.907 47.6184 114.529 47.4297L113.989 47.3877V49.6094Z",
    fill: "white",
    stroke: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M113.663 53.623C113.843 53.623 113.989 53.7694 113.989 53.9502V58.6543L114.064 58.7754L115.56 61.1934C115.643 61.3282 115.617 61.4995 115.507 61.6035L115.454 61.6436C115.399 61.6774 115.341 61.6924 115.282 61.6924C115.171 61.6924 115.066 61.6367 115.004 61.5371H115.003L113.522 59.1426L113.488 59.0879L113.441 59.0439L113.411 59.0078C113.382 58.9675 113.359 58.9124 113.351 58.8398L113.349 58.8223L113.345 58.8047C113.343 58.7949 113.341 58.7866 113.34 58.7812C113.339 58.7786 113.339 58.7758 113.339 58.7744C113.339 58.7728 113.338 58.7719 113.338 58.7715C113.338 58.7715 113.34 58.7817 113.342 58.7959H113.34C113.339 58.7846 113.338 58.7742 113.336 58.7646V53.9502C113.336 53.7696 113.483 53.6231 113.663 53.623Z",
    fill: "white",
    stroke: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M240.172 41.3643C249.783 41.3643 257.603 49.1842 257.603 58.7949C257.603 68.4056 249.783 76.2256 240.172 76.2256C230.561 76.2256 222.741 68.4056 222.741 58.7949C222.741 49.1842 230.561 41.3643 240.172 41.3643ZM240.172 42.4736C231.173 42.4736 223.851 49.7946 223.851 58.7939C223.851 67.7933 231.172 75.1152 240.172 75.1152C249.171 75.1152 256.492 67.7941 256.492 58.7939C256.492 49.7938 249.171 42.4736 240.172 42.4736Z",
    fill: "white",
    stroke: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M240.023 62.7998C241.13 62.7999 242.028 63.6976 242.028 64.8047C242.028 65.9117 241.13 66.8094 240.023 66.8096C238.916 66.8096 238.019 65.9117 238.019 64.8047C238.019 63.6975 238.916 62.7998 240.023 62.7998Z",
    fill: "white",
    stroke: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M240.024 58.4873C241.776 58.4874 243.459 59.1881 244.692 60.4219L244.933 60.6758C245.084 60.8446 245.071 61.1032 244.903 61.2549C244.822 61.3273 244.723 61.3613 244.627 61.3613C244.513 61.3613 244.402 61.3156 244.321 61.2256C243.226 60.0074 241.66 59.3096 240.023 59.3096C238.613 59.3096 237.271 59.82 236.218 60.75L236.011 60.9414C235.849 61.0993 235.588 61.0962 235.43 60.9336C235.271 60.7704 235.275 60.5103 235.438 60.3525C236.675 59.1485 238.303 58.4873 240.024 58.4873Z",
    fill: "white",
    stroke: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M240.022 55.0947C242.779 55.0947 245.442 56.254 247.324 58.2744C247.479 58.441 247.47 58.6999 247.305 58.8535C247.226 58.9268 247.125 58.9639 247.024 58.9639C246.913 58.9638 246.804 58.9193 246.724 58.833L246.388 58.4902C244.673 56.8272 242.428 55.916 240.022 55.916C237.606 55.9161 235.326 56.8462 233.606 58.5361C233.464 58.6757 233.247 58.6909 233.09 58.585L233.026 58.5322C232.867 58.3698 232.869 58.1089 233.03 57.9502C234.905 56.1082 237.388 55.0948 240.022 55.0947Z",
    fill: "white",
    stroke: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M240.021 51.4482C243.797 51.4483 247.301 52.9549 249.896 55.6934C250.052 55.8581 250.046 56.1189 249.881 56.2754L249.879 56.2773C249.802 56.3515 249.702 56.3887 249.6 56.3887C249.49 56.3886 249.382 56.3462 249.301 56.2607V56.2598C246.865 53.6886 243.567 52.2706 240.022 52.2705C236.641 52.2705 233.447 53.5818 231.032 55.96C230.87 56.1191 230.611 56.1177 230.45 55.9551C230.292 55.794 230.292 55.5331 230.454 55.373C233.026 52.8414 236.423 51.4482 240.021 51.4482Z",
    fill: "white",
    stroke: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M186.214 41.1836V42.6709C186.214 48.3004 183.387 53.543 178.705 56.6416C174.023 53.5429 171.197 48.3001 171.197 42.6709V41.1836L178.705 39.0625L186.214 41.1836Z",
    fill: "white",
    stroke: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M178.705 29.5869C188.316 29.5869 196.136 37.4069 196.136 47.0176C196.136 56.6283 188.316 64.4482 178.705 64.4482C169.094 64.4482 161.274 56.6283 161.274 47.0176C161.274 37.4069 169.094 29.5869 178.705 29.5869ZM178.705 30.6963C169.706 30.6963 162.384 38.0173 162.384 47.0176C162.384 56.0178 169.705 63.3379 178.705 63.3379C187.705 63.3379 195.026 56.017 195.026 47.0176C195.026 38.0182 187.705 30.6963 178.705 30.6963Z",
    fill: "white",
    stroke: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3662 88.4854V88.8545H52.71V88.4854H53.3662ZM53.3662 86.3555V86.7158H52.71V86.3555H53.3662ZM53.3662 84.2178V84.5869H52.71V84.2178H53.3662ZM53.3662 82.0801V82.4492H52.71V82.0801H53.3662ZM53.3662 79.9502V80.3105H52.71V79.9502H53.3662ZM53.3662 77.8125V78.1816H52.71V77.8125H53.3662Z",
    fill: "white",
    stroke: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3008 76.1318C50.759 76.1318 51.1328 76.5057 51.1328 76.9639V91.7578L51.3574 91.9062L52.0039 92.333C52.8792 92.9111 53.4004 93.8779 53.4004 94.9199C53.4003 95.7479 53.078 96.5238 52.4922 97.1104C51.9066 97.6958 51.1299 98.0176 50.3018 98.0176C50.1815 98.0176 50.0606 98.0112 49.9414 97.998C48.5633 97.8457 47.4219 96.7356 47.2344 95.3691C47.0678 94.1578 47.5923 92.9982 48.5996 92.333L49.2461 91.9062L49.4697 91.7578V76.9639C49.4697 76.5054 49.8432 76.132 50.3008 76.1318Z",
    fill: "white",
    stroke: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2998 69.751C59.9104 69.7511 67.7314 77.572 67.7314 87.1826C67.7314 96.7932 59.9104 104.614 50.2998 104.614C40.6892 104.614 32.8682 96.7932 32.8682 87.1826C32.8682 77.5719 40.6891 69.751 50.2998 69.751ZM50.2998 70.8633C41.303 70.8633 33.9805 78.1858 33.9805 87.1826C33.9805 96.188 41.3032 103.501 50.2998 103.501C59.3046 103.501 66.6269 96.1881 66.627 87.1826C66.627 78.1857 59.3049 70.8634 50.2998 70.8633Z",
    fill: "white",
    stroke: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1582 101.404L71.1999 113.446",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M119.085 75.208L125.423 88.7285",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M280.697 101.404L268.655 113.446",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M233.094 73.7988L225.84 88.7279",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M179.294 64.0117V79.856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6873_16150",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6873_16150",
    transform: "matrix(0.00135337 0 0 0.000793786 0.202259 0.44761)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6873_16150",
    width: 440,
    height: 132,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCarousel01);
export default __webpack_public_path__ + "static/media/login-carousel-01.ec2cdb451c99b25fe7b8393b69d896fc.svg";
export { ForwardRef as ReactComponent };